<!-- 维修管理 -->
<template>
  <div class="msgSetting business-page">
    <navLeft :nav="nav"></navLeft>
    <div class="business-content">
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="$route.name"/>
      </keep-alive>
      <router-view  v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>
<script>
import navLeft from "@/components/business/navLeft.vue";
export default {
  name: "",
  components: {
    navLeft,
  },
  data() {
    return {
      nav: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.nav = this.$util.getNode("AutomotiveRepairSys", 2);
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
</style>
